import { createContext } from 'react';

const SignInProps = createContext({
  errors : null,
});

export default SignInProps;
